import { createMutationGroup } from "../../core/api/mutations";
import { PlanOfCareDutyId, VisitInstanceId } from "../../shared/schema/schema";

export type UndoReassignMissedDutyParams = {
  planOfCareDutyId: PlanOfCareDutyId;
  /**
   * WHICH make-up to retract, named by the visit carrying it — what the
   * coordinator sees ("made up on Tuesday"). Omitted retracts every live make-up
   * of this duty from this visit, which is what a row that knows only a count
   * can ask for.
   */
  targetVisitInstanceId?: VisitInstanceId;
};

export default createMutationGroup(({ api, createMutation }) => ({
  /** Undoes a missed duty reassignment. `visitInstanceId` is the visit that missed the duty. */
  undoReassignMissedDuty: (visitInstanceId: VisitInstanceId) =>
    createMutation({
      // anyRequest, not api.delete: `targetVisitInstanceId` reached this route
      // after the last `pnpm openapi:local`, so the generated schema gives the
      // endpoint no query parameters at all and the typed client would refuse it.
      // Move back to api.delete once the schema is regenerated. The route answers
      // 204, so there is no response to validate either way.
      mutationFn: (params: UndoReassignMissedDutyParams) =>
        api.anyRequest<void>(
          "DELETE",
          "/agencies/:agencyId/agency_members/:agencyMemberId/visit_instances/:visitInstanceId/missed_duties/:planOfCareDutyId/reassign",
          {
            path: { planOfCareDutyId: params.planOfCareDutyId, visitInstanceId },
            query:
              params.targetVisitInstanceId !== undefined
                ? { targetVisitInstanceId: params.targetVisitInstanceId }
                : undefined,
          }
        ),
    }),
}));
